import { render, staticRenderFns } from "./PlaceData.vue?vue&type=template&id=758cbbed&scoped=true"
import script from "./PlaceData.vue?vue&type=script&lang=ts"
export * from "./PlaceData.vue?vue&type=script&lang=ts"
import style0 from "./PlaceData.vue?vue&type=style&index=0&id=758cbbed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758cbbed",
  null
  
)

export default component.exports